import { render, staticRenderFns } from "./sortIconWithLoader.vue?vue&type=template&id=74120be4&scoped=true&"
import script from "./sortIconWithLoader.vue?vue&type=script&lang=js&"
export * from "./sortIconWithLoader.vue?vue&type=script&lang=js&"
import style0 from "./sortIconWithLoader.vue?vue&type=style&index=0&id=74120be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74120be4",
  null
  
)

export default component.exports